import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { FitnessGoalsDataService, FitnessGoalsColumnsService } from '../../../services';
import { FitnessGoal, FitnessGoalsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-fitness-goal-details',
  templateUrl: './fitness-goal-details.component.html',
  styleUrls: ['./fitness-goal-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class FitnessGoalDetailsComponent implements OnInit, OnDestroy {

  public fitnessGoal: FitnessGoal = {};
  public fitnessGoals: FitnessGoal[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private fitnessGoalsDataService: FitnessGoalsDataService,
    private fitnessGoalsColumnsService: FitnessGoalsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Fitness Goal - Details');
        this.getFitnessGoal(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.fitnessGoal !== 'undefined') {
      this.fitnessGoal = this.dynamicDialogConfig.data.fitnessGoal;
    }
    this.columns = this.fitnessGoalsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getFitnessGoal(id: number): void {
    this.isLoading = true;
    this.fitnessGoalsDataService.getFitnessGoal(id).subscribe((response: FitnessGoal|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.fitnessGoal = response;
      }
    });
  }

  list() {
    this.router.navigate(['/fitness-goals']);
  }

  add() {
    this.router.navigate(['/fitness-goals/add']);
  }

  edit() {
    this.router.navigate(['/fitness-goals/edit/' + this.fitnessGoal.id]);
  }

}
@Component({
  selector: 'app-fitness-goal-details',
  templateUrl: './fitness-goal-details.component.html',
  styleUrls: ['./fitness-goal-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogFitnessGoalDetailsComponent extends FitnessGoalDetailsComponent {
}

